// A `<th>` that drives a useTableSort() hook on click. Appends the ▲/▼ indicator
// and sets aria-sort for screen readers (the inline exporter-register cells never
// did — this is the blessed way to wire a sortable header going forward).
//
// Pass the same className you'd give a plain header cell (alignment, padding,
// colour); the cursor / select-none affordance is added here so the component
// stays theme-neutral. Non-sortable columns keep using a plain <th>.
import type { ReactNode } from 'react'
import type { SortState } from '@/hooks/useTableSort'

interface SortHandle {
  sort: SortState
  toggle: (key: string) => void
  indicator: (key: string) => string
}

export default function SortableTh({ hook, sortKey, className = '', title = 'Sort', children }: {
  hook: SortHandle
  sortKey: string
  className?: string
  title?: string
  children?: ReactNode
}) {
  const active = hook.sort.key === sortKey
  return (
    <th
      scope="col"
      onClick={() => hook.toggle(sortKey)}
      aria-sort={active ? (hook.sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}
      title={title}
      className={`cursor-pointer select-none ${className}`}
    >
      {children}{hook.indicator(sortKey)}
    </th>
  )
}
